<app-entity-mat-dialog-title title="Enrollment Policies"></app-entity-mat-dialog-title>
<div mat-dialog-content>
    <mat-progress-spinner class="mx-auto my-3" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

    <form [formGroup]="enrollmentPoliciesForm">
      <app-success-message [message]="this.successMessage"></app-success-message>
      <app-error-message [message]="this.errorMessage"></app-error-message>

      <h6 class="text-muted fw-semibold mb-3">Enrollment Agreement</h6>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Active Agreement</mat-label>
        <mat-select formControlName="enrollmentAgreement">
          <mat-option value="">None selected</mat-option>
          <mat-option *ngFor="let agreement of enrollmentAgreements" [value]="agreement.id">
            {{ agreement.title }}
            <span *ngIf="agreement.field_is_system?.[0]?.value === '1'" class="text-muted small ms-1">(System)</span>
          </mat-option>
        </mat-select>
        <mat-hint>Select which enrollment agreement form is presented to customers.</mat-hint>
      </mat-form-field>

      <hr class="my-4">

      <h6 class="text-muted fw-semibold mb-3">Lesson Policies</h6>

      <mat-checkbox formControlName="allowNegativeEnrollments">
        Allow Negative Enrollments
      </mat-checkbox>
      <p class="text-muted small mt-1 mb-0">When enabled, students can continue taking lessons even if their enrollment balance goes below zero. This allows for more flexible lesson scheduling while tracking outstanding balances.</p>
    </form>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary"
          [disabled]="showProgressSpinner"
          (click)="save()">
    <mat-spinner *ngIf="showProgressSpinner" diameter="20" class="d-inline-block"></mat-spinner>
    <span *ngIf="!showProgressSpinner">Update</span>
  </button>
</mat-dialog-actions>
